import * as Types from '@trello/graphql/generated';

import { useQuickLoad } from '@trello/quickload';
import type { TrelloQueryHookOptions, TrelloLazyQueryHookOptions } from '@trello/quickload';
import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const NavigateToBoardCardDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"NavigateToBoardCardData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"card"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cardId"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idBoard"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"NavigateToBoardCardData","document":NavigateToBoardCardDataDocument}} as const;
export type NavigateToBoardCardDataQueryVariables = Types.Exact<{
  cardId: Types.Scalars['ID']['input'];
}>;


export type NavigateToBoardCardDataQuery = (
  { __typename: 'Query' }
  & { card?: Types.Maybe<(
    { __typename: 'Card' }
    & Pick<Types.Card, 'id' | 'idBoard'>
  )> }
);

/**
 * __useNavigateToBoardCardDataQuery__
 *
 * To run a query within a React component, call `useNavigateToBoardCardDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useNavigateToBoardCardDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNavigateToBoardCardDataQuery({
 *   variables: {
 *      cardId: // value for 'cardId'
 *   },
 * });
 */
export function useNavigateToBoardCardDataQuery(
  baseOptions: TrelloQueryHookOptions<
    NavigateToBoardCardDataQuery,
    NavigateToBoardCardDataQueryVariables
  >,
) {
  const isQuickLoading = useQuickLoad({
    waitOn: baseOptions?.waitOn || ['None'],
    document: NavigateToBoardCardDataDocument,
    skip: baseOptions?.skip,
  });
  const options = {
    ...defaultOptions,
    ...baseOptions,
    skip: isQuickLoading || baseOptions?.skip,
  };
  const result = Apollo.useQuery<
    NavigateToBoardCardDataQuery,
    NavigateToBoardCardDataQueryVariables
  >(NavigateToBoardCardDataDocument, options);
  // reconstruct result because modifying the useQuery result actually changes apollo behavior because of memoization
  const trelloResult = { ...result };
  if (isQuickLoading) {
    trelloResult.loading = true;
  }

  return trelloResult;
}
export function useNavigateToBoardCardDataLazyQuery(
  baseOptions?: TrelloLazyQueryHookOptions<
    NavigateToBoardCardDataQuery,
    NavigateToBoardCardDataQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    NavigateToBoardCardDataQuery,
    NavigateToBoardCardDataQueryVariables
  >(NavigateToBoardCardDataDocument, options);
}
export type NavigateToBoardCardDataQueryHookResult = ReturnType<
  typeof useNavigateToBoardCardDataQuery
>;
export type NavigateToBoardCardDataLazyQueryHookResult = ReturnType<
  typeof useNavigateToBoardCardDataLazyQuery
>;
export type NavigateToBoardCardDataQueryResult = Apollo.QueryResult<
  NavigateToBoardCardDataQuery,
  NavigateToBoardCardDataQueryVariables
>;
